import type { Ref } from 'vue';

import type Stepper from './Stepper.vue';

/**
 * Helper type for the template ref (the "ref" attribute) on a Stepper instance
 * @see: https://vuejs.org/guide/typescript/composition-api.html#typing-component-template-refs
 */
export type StepperRef = Ref<InstanceType<typeof Stepper> | null>;

export enum StepperOrientationEnum {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
export type StepperOrientation = `${StepperOrientationEnum}`;

export type StepperTheme = 'dark' | 'light';
